"use client"

import { motion, useInView } from "framer-motion"
import { useRef } from "react"
import {
  DENDROMAP_MARKETING_HEADLINE,
  DENDROMAP_MARKETING_PARAGRAPHS,
} from "./home-marketing-content"

export function DendromapMarketingSection(): JSX.Element {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  return (
    <section id="dendromap-marketing" className="bg-forest-tint py-16 md:py-20" ref={ref}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="mx-auto flex max-w-4xl flex-col gap-8 rounded-2xl border border-primary/20 bg-card p-6 shadow-forest-lg md:p-10"
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-col items-center gap-4 text-center">
            <img
              src="/images/logos/dendromap.svg"
              alt="Dendromap"
              className="h-20 w-auto max-w-[280px] object-contain sm:h-24 sm:max-w-[340px]"
            />
            <h2 className="text-2xl font-semibold leading-snug tracking-tight text-foreground md:text-3xl lg:text-4xl">
              {DENDROMAP_MARKETING_HEADLINE}
            </h2>
          </div>

          <div className="flex flex-col gap-5 text-center md:text-left">
            {DENDROMAP_MARKETING_PARAGRAPHS.map((paragraph) => (
              <p
                key={paragraph.slice(0, 40)}
                className="text-base leading-relaxed text-muted-foreground"
              >
                {paragraph}
              </p>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}
